import { useState } from 'react';
import type { UseSetLabel } from './type';

export const useSetLabel: UseSetLabel = () => {
  const [optionList, setOptionList] = useState<any[]>([]);
  return {
    optionList,
    setOptionList,
  };
};
